<form class="gap-lg grid" [formGroup]="form">
  <div hlmField>
    <label for="input-titre" hlmLabel labelRequired>Titre</label>
    <input id="input-titre" hlmInput formControlName="titre" />
  </div>
  <div hlmField>
    <label for="rangepicker-date" hlmLabel labelRequired>Période d'affichage</label>
    <hlm-date-range-picker formControlName="date"></hlm-date-range-picker>
    <p hlmFieldDescription>Sélectionnez la date de début et de fin de l'affichage du message</p>
  </div>
  <div hlmField>
    <label hlmFieldLabel for="textarea-contenu" labelRequired>Contenu</label>
    <quill-editor id="textarea-contenu" [modules]="modules" formControlName="contenu" />
  </div>
</form>
